import { SEO } from "@/components/SEO";

export const PlanosSEO = () => (
  <SEO 
    title="Planos e Preços - Pididex Pro" 
    description="Conheça o Pididex Pro. Por apenas R$ 89,90/mês você tem produtos ilimitados, pagamentos online e 15 dias de teste grátis. Comece agora!"
  />
);
